export default __webpack_public_path__ + "static/media/Half-Round-PU-insulation.d15a53e4.jpg";